import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ListFilterToolbarComponent } from "../../components/list-filter-toolbar/list-filter-toolbar.component";
import { SharedModule } from "../../shared.module";
import { ExportWizardDialogComponent } from "./export-wizard-dialog/export-wizard-dialog.component";
import { FilterTypeComponent } from "./grid-settings-flyout/filter-type/filter-type.component";
import { GridSettingsFlyoutComponent } from "./grid-settings-flyout/grid-settings-flyout.component";
import { SearchInputComponent } from "./grid-settings-flyout/search-input/search-input.component";
import { TableViewSelectorComponent } from "./table-view-selector/table-view-selector.component";

@NgModule({
  declarations: [
    GridSettingsFlyoutComponent,
    TableViewSelectorComponent,
    ExportWizardDialogComponent,
    FilterTypeComponent,
    SearchInputComponent,
  ],
  imports: [CommonModule, SharedModule, ListFilterToolbarComponent],
  exports: [
    GridSettingsFlyoutComponent,
    TableViewSelectorComponent,
    ExportWizardDialogComponent,
    FilterTypeComponent,
    SearchInputComponent,
  ],
})
export class GridChromeModule {}
